import { WatchFaceType } from "../dto/WatchFace.dto";

export interface WatchfacePreviewSource {
  readonly wfType: WatchFaceType;
  readonly complicationsInfo?: {
    readonly previewUrl?: string;
    readonly videoPreviewUrl?: string;
  } | null;
  readonly styles?: { readonly previewUrl?: string } | null;
  readonly edgeToEdgeInfo?: { readonly previewUrl?: string } | null;
}

export interface WatchfacePreviewMedia {
  readonly src: string;
  readonly type: "img" | "video";
}

function isWatchfacePreviewImage(previewUrl: string): boolean {
  const extension = previewUrl.split(".").pop()?.toLowerCase() ?? "";
  return ["png", "jpg", "jpeg", "heic"].includes(extension);
}

export function getWatchfacePreviewMedia(
  watchface: WatchfacePreviewSource
): WatchfacePreviewMedia {
  let src = "";
  if (watchface.wfType === WatchFaceType.Complication) {
    src =
      watchface.complicationsInfo?.videoPreviewUrl ||
      watchface.complicationsInfo?.previewUrl ||
      "";
  } else {
    src =
      watchface.styles?.previewUrl ||
      watchface.edgeToEdgeInfo?.previewUrl ||
      "";
  }
  return {
    src,
    type: isWatchfacePreviewImage(src) ? "img" : "video",
  };
}
